import { HttpClient } from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {GeneralConfig} from '../shared/GeneralConfig';
import {MiniBookAdminService} from './mini-book-admin.service';

export class GeneralconfigService {

  constructor(private http: HttpClient, private baseService: MiniBookAdminService) {
  }

  getGeneralConfig(): Observable<GeneralConfig> {
    return this.http.get<any>(`${this.baseService.tenant}/generalconfig`).pipe(
      map<any, GeneralConfig>(data => GeneralConfig.createFromJson(data))
    );
  }

  updateGeneralConfig(generalConfig: GeneralConfig): Observable<GeneralConfig> {
    return this.http.put<any>(`${this.baseService.tenant}/generalconfig`, generalConfig.toJson()).pipe(
      map<any, GeneralConfig>(data => GeneralConfig.createFromJson(data))
    );
  }

}
